import type { IProductItem } from '@inter-ikea-kompis/types';

/**
 * Item handling utility.
 */
export default class ItemUtility {
	/**
	 * Returns an item string to be used in the request URL.
	 *
	 * @param items Array of items.
	 * @returns Item string.
	 */
	public static getItemsString(items: IProductItem[]): string {
		return items.map((item) => item.type.toUpperCase() + '-' + item.id).join(',');
	}

	/**
	 * Returns item sets based on the maximum allowed items per request.
	 *
	 * @param items Array of items to parse.
	 * @param maxItemsPerRequest Maximum items in the request.
	 * @returns Product sets.
	 */
	public static getItemSets(
		items: IProductItem[],
		maxItemsPerRequest: number
	): Array<IProductItem[]> {
		const sets: IProductItem[][] = [[]];
		let currentSet = sets[0];

		for (let i = 0, max = items.length; i < max; i++) {
			if (currentSet.length === maxItemsPerRequest) {
				currentSet = [];
				sets.push(currentSet);
			}

			if (items[i].id && items[i].type) {
				currentSet.push(items[i]);
			}
		}

		return sets;
	}
}
